/**
 * @fileoverview Roadmap & Known Issues for the project
 * @author Scott
 * @date 2025-09-18
 * @version 1.0.0
 * @copyright 2025 MyYenta
 */

export const ROADMAP = {
    "Limited Time Features": [
        "We are still stress testing, so while we are doing that. Free users will have unlimited test result per month."
    ],
    "Work in Progress": [
        "Test enter & exit question customization",
        "Test theming (branding)",
        "Add 'revised answer' metric point to the algo",
        "Build 'question sets' that rotate and build"
    ],
    "Known Issues": [
        "Not all stats are wired up to show 'live' data -- like test counts, team counts, etc. -- Data involved with personality result insights is complete",
        "There may be a weird glich with the client-to-server communication that cause some data to fail trying to load, refresh the page fixes the issue. (This may only be in issue in our dev server)",
        "When signing up for an account, you will get an email & be taken to a 'activation' form. This is do to redundancy in the sign up process, I don't really consider this a bug, but it is wierd behavior that will likely change in the future"
    ],
    "Roadmap": ["'Gamize' the test with domain specific themes/topics", "Bundle Prisma without Rust Binaries", "Accepting feature requests from YOU!"],
    // https://www.prisma.io/docs/orm/reference/prisma-client-reference
} as const;